import { ArrowClockwise24Regular, Dismiss24Regular } from '@fluentui/react-icons';

interface NewVersionBannerProps {
  onReload: () => void;
  onDismiss: () => void;
}

export function NewVersionBanner({ onReload, onDismiss }: NewVersionBannerProps) {
  return (
    <div
      className="w-full flex items-center justify-between gap-3 px-4 py-2.5 bg-primary text-primary-foreground shrink-0"
      style={{ fontSize: 'var(--text-sm)' }}
      role="alert"
    >
      <span className="flex items-center gap-2">
        <ArrowClockwise24Regular className="w-4 h-4 flex-shrink-0" />
        <span>Nova versão disponível. Actualiza a página para obteres as últimas melhorias.</span>
      </span>
      <div className="flex items-center gap-2 flex-shrink-0">
        <button
          onClick={onReload}
          className="flex items-center gap-1.5 px-3 py-1 rounded bg-primary-foreground text-primary font-medium hover:opacity-90 transition-opacity"
          style={{ fontSize: 'var(--text-sm)', borderRadius: 'var(--radius-button)' }}
        >
          <ArrowClockwise24Regular className="w-3.5 h-3.5" />
          Actualizar
        </button>
        <button
          onClick={onDismiss}
          className="p-1 rounded hover:bg-primary-foreground/20 transition-colors"
          style={{ borderRadius: 'var(--radius-button)' }}
          title="Dispensar"
          aria-label="Dispensar aviso"
        >
          <Dismiss24Regular className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
}
